import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, prop?: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      if (prop) {
        return item[prop]?.toString().toLowerCase().includes(searchText);
      }
      return Object.values(item).some(val =>
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        val?.toString().toLowerCase().includes(searchText)
      );
    });
  }
}